import Alpine from 'alpinejs';
import intersect from '@alpinejs/intersect';
import imagesLoaded from 'imagesloaded';
import animateScrollTo from 'animated-scroll-to';
import Swiper, {Navigation, Pagination} from 'swiper';
import axios from 'axios';
import 'swiper/css/bundle';
import collapse from '@alpinejs/collapse';

Alpine.plugin(intersect);
Alpine.plugin(collapse);

window.Alpine = Alpine;
window.autoScrolling = false;
window.toggleDescription = toggleDescription;
window.mobileAboutInit = mobileAboutInit;
window.toggleSection = toggleSection;
window.playVideo = playVideo;
window.initGallery = initGallery;
window.aboutSectionIntersect = aboutSectionIntersect;

function init() {
    Alpine.start();

    loaderInit();
    loadImages();
    initForms();

    window.setTimeout(() => {
        desktopAboutSectionSizing();
    },100);
}

window.addEventListener('resize', function(){
    desktopAboutSectionSizing();
});

function initForms() {
    const allForms = document.querySelectorAll('form');

    const aInstance = axios.create({
        headers: { 'X-Requested-With': 'XMLHttpRequest' }
    });

    allForms.forEach((form) => {
        form.addEventListener('submit', (e) => {
            e.preventDefault();

            form.classList.add('submitting');
            form.querySelector('.success').classList.add('hidden');
            form.querySelector('.error').classList.add('hidden');

            aInstance.post(form.action, new FormData(form))
                .then(response => {

                    if (response.data.success) {

                        form.querySelector('.success').innerHTML = "Submission Successful!";
                        form.querySelector('.success').classList.remove('hidden');
                        form.querySelector('.inner-content').classList.add('hidden');

                    } else {
                        console.error('Form submission failed');
                        console.error(JSON.parse(response.data));

                        form.querySelector('.error').innerHTML = "Error, please try again.";
                        form.querySelector('.error').classList.remove('hidden');
                    }

                    form.classList.remove('submitting');
                })
                .catch(function (error) {
                    console.error('Form submission failed');
                    const errorMessage = error.response.data.error;

                    form.querySelector('.error').innerHTML = "Error, please try again.";
                    form.querySelector('.error').classList.remove('hidden');

                    form.classList.remove('submitting');
                });
        })
    });
}

Alpine.data('featuredImageSlider', (element) => ({
    init(){
        const swiper = new Swiper(this.$el, {
            modules: [Pagination],
            loop: true,
            slidesPerView: 1,
            pagination: {
                el: '.swiper-pagination',
                clickable: true,
            }
            // navigation: {
            //     nextEl: '.next-button',
            //     prevEl: '.prev-button',
            // },
            // on : {
            //     init: function(swiper) {
            //         counter.querySelector('.total').innerHTML = Math.ceil(swiper.slides.length / 2);
            //     },
            //     slideChange: function(swiper) {
            //         counter.querySelector('.current').innerHTML = swiper.realIndex + 1;
            //     }
            // }
        });
    }
}));


function initGallery(element) {

    const counter = element.querySelector('.counter');

    const swiper = new Swiper(element, {
        modules: [Navigation],
        loop: true,
        navigation: {
            nextEl: '.next-button',
            prevEl: '.prev-button',
        },
        on : {
            init: function(swiper) {
                counter.querySelector('.total').innerHTML = Math.ceil(swiper.slides.length / 2);
            },
            slideChange: function(swiper) {
                counter.querySelector('.current').innerHTML = swiper.realIndex + 1;
            }
        }
    });
}

function desktopAboutSectionSizing() {

    if (document.querySelectorAll('.about-gallery') && window.innerWidth > 768) {
        const gallerySections = document.querySelectorAll('.about-gallery .gallery-block');
        const contentSections = document.querySelectorAll('.js-about-sections section');

        gallerySections.forEach((section, index) => {
            section.style.height = contentSections[index].scrollHeight + 'px';
        });
    }
}

function playVideo(element) {
    const videoContainer = element.closest('.video-container');
    const videoID = videoContainer.getAttribute('data-video-id');

    const iframeHTML = '<iframe src="https://player.vimeo.com/video/' + videoID + '?autoplay=1" allow="autoplay; fullscreen; picture-in-picture" allowfullscreen></iframe>';

    videoContainer.insertAdjacentHTML('beforeend', iframeHTML);

    videoContainer.classList.add('playing');
}

function toggleSection($el) {
    const sectionTitle = $el.getAttribute('data-title');
    const section = $el.closest('.about-inner');

    const buttons = section.querySelectorAll('.mobile-section-selector button');
    const images = section.querySelectorAll('.gallery-block');
    const sections = section.querySelectorAll('.js-about-sections section');
    const mainMenuItems = document.querySelectorAll('.about-inner-section');

    buttons.forEach((button) => {
        button.classList.remove('active');
    });

    mainMenuItems.forEach((menuItem) => {
        menuItem.classList.remove('current');

        if(menuItem.innerHTML.toLowerCase() == sectionTitle) {
            menuItem.classList.add('current');
        }
    });

    $el.classList.add('active');

    images.forEach((image, index) => {
        if(index == $el.getAttribute('data-index')) {
            image.classList.add('mobile-visible');
        } else {
            image.classList.remove('mobile-visible');
        }
    });

    sections.forEach((section) => {
        if (section.getAttribute('data-title') == sectionTitle) {

            const headerHeight = document.querySelector('.about-gallery').scrollHeight + 60;

            animateScrollTo(section, {
                verticalOffset: -headerHeight
            });
        }
    });
}

function aboutSectionIntersect(element) {

    const mainMenuItems = document.querySelectorAll('.menu-right .about-inner-section');
    const mobileMenuItems = document.querySelectorAll('.mobile-section-selector button');

    if(window.innerWidth > 1023) {
        mainMenuItems.forEach((menuItem) => {
            if(element.getAttribute('data-title') == menuItem.innerHTML.toLowerCase()) {
                menuItem.classList.add('current');
            } else {
                menuItem.classList.remove('current');
            }
        });
    } else {
        mainMenuItems.forEach((menuItem) => {
            if (element.getAttribute('data-title') == menuItem.innerHTML.toLowerCase()) {
                menuItem.classList.add('current');
            } else {
                menuItem.classList.remove('current');
            }
        });

        // console.log(element.getAttribute('data-title'));

        // mobileMenuItems.forEach((button) => {
        //     if (button.getAttribute('data-title') == element.getAttribute('data-title')) {
        //         button.classList.add('active');
        //     } else {
        //         button.classList.remove('active');
        //     }
        // });
    }
}

function mobileAboutInit($el) {
    const section = $el;
    const activeImage = section.querySelector('.image-container');
    const buttons = section.querySelectorAll('.mobile-section-selector button');
    let activeButton = null;

    const anchor = window.location.hash.slice(1);



    if(window.innerWidth < 1024) {
        if(anchor) {
            buttons.forEach((button) => {
                if(button.getAttribute('data-title') == anchor) {
                    activeButton = button;
                }
            });
        } else {
            activeButton = buttons[0];
        }

        activeImage.classList.add('mobile-visible');

        window.setTimeout(() => {
            activeButton.click();
        }, 50);

        window.addEventListener('hashchange', function () {
            const anchor = window.location.hash.slice(1);

            buttons.forEach((button) => {
                if (button.getAttribute('data-title') == anchor) {
                    button.click();
                }
            });
        }, false);
    }
}

function toggleDescription(element) {
    const description = element.closest('.description');

    console.log('hello');

    description.classList.toggle('open');
}

function loadImages() {
    const imgLoad = new imagesLoaded(document.body);

    imgLoad.on('progress', function (instance, image) {
        var result = image.isLoaded ? 'loaded' : 'broken';

        if(image.isLoaded) {
            image.img.classList.add('loaded');
        } else {
            console.log('image is ' + result + ' for ' + image.img.src);
        }
    });
}

function loaderInit() {
    if (document.querySelector('.home-lander')) {
        const loaderScreen = document.querySelector('.home-lander');

        if (!sessionStorage.getItem("existingUser")) {
            sessionStorage.setItem("existingUser", true);

            document.body.classList.add('loader-animating');

            window.addEventListener('load', () => {
                window.setTimeout(() => {
                    window.scrollTo(0, 0);
                }, 50)
                window.setTimeout(() => {
                    document.querySelector('.home-lander .inner .logo').classList.add('show-logo');
                }, 500);
            });

            window.setTimeout(() => {
                document.body.classList.add('animation-in-progress');


                window.setTimeout(() => {
                    document.body.classList.remove('animation-in-progress');
                    document.body.classList.remove('loader-animating');
                }, 2000);
            }, 5000);
        }
    }
}

init();
